// src/components/data/InvestorLogo.jsx
import { useState, useMemo, useCallback } from 'react';
import profileDefault from '../../icons/profile-default.svg';

const CDN_BASE = 'https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/investor-logos';
const ORIGIN_BASE = 'https://crino-cdn.nyc3.digitaloceanspaces.com/investor-logos';
const EXTENSIONS = ['png', 'jpg', 'jpeg', 'svg'];

const InvestorLogo = ({ id, country, className = 'w-10 h-10', alt = 'Investor logo' }) => {
  const folder = country ? encodeURIComponent(country) : '';
  const [extIndex, setExtIndex] = useState(0);
  const [useOrigin, setUseOrigin] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  // Build src URL based on current state
  const src = useMemo(() => {
    if (extIndex === -1) return profileDefault;
    const prefix = useOrigin ? ORIGIN_BASE : CDN_BASE;
    const basePath = `${prefix}/${folder}/${id}`;
    return `${basePath}.${EXTENSIONS[extIndex]}`;
  }, [folder, id, extIndex, useOrigin]);

  // Handle errors: try next extension, then origin, then fallback
  const handleError = useCallback(() => {
    if (extIndex + 1 < EXTENSIONS.length) {
      setExtIndex(extIndex + 1);
    } else if (!useOrigin) {
      setUseOrigin(true);
      setExtIndex(0);
    } else {
      setExtIndex(-1);
    }
  }, [extIndex, useOrigin]);

  const handleLoad = useCallback(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`relative ${className} rounded-full shadow-inner bg-gray-100 overflow-hidden`}>  
      {/* Skeleton/background circle is the div itself */}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        onError={handleError}
        onLoad={handleLoad}
        className={`absolute inset-0 w-full h-full rounded-full object-cover transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
      />
    </div>
  );
};

export default InvestorLogo;

